import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import $ from 'jquery'
import 'bootstrap/dist/js/bootstrap.min.js'
import animated from 'animate.css'
import 'lib-flexible/flexible'
import VueLazyload from 'vue-lazyload'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import moment from 'moment'
import store from './store'
import 'swiper/dist/css/swiper.css'
import BaiduMap from 'vue-baidu-map'
import 'view-design/dist/styles/iview.css'
import './assets/css/common.less'

import './assets/fonts/fonts.css'

Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.use(animated)
Vue.use(VueLazyload)
Vue.use(BaiduMap, {
  ak: 'NlzVlxr5zwZwQ3aghkoqpKrvizvYbttH'
})
Vue.prototype.$video = Video
Vue.prototype.$moment = moment
moment.locale('zh-cn')

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  $,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js